import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { useI18n } from "../../contexts/I18nContext";
import { MessageSquare, Calendar, Users, Trophy, Bell, Activity } from "lucide-react";

const iconFor = (type) => {
  if (type === "new_message") return MessageSquare;
  if (type === "training_created") return Calendar;
  if (type === "player_added") return Users;
  if (type === "match_created") return Trophy;
  if (type === "rsvp_update") return Calendar;
  return Bell;
};

export default function ActivityFeed({ limit = 8 }) {
  const { t, lang } = useI18n();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/activity").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const ago = (iso) => {
    const diff = Math.max(0, Date.now() - new Date(iso).getTime());
    const m = Math.floor(diff / 60000);
    if (m < 1) return lang === "bg" ? "сега" : "now";
    if (m < 60) return `${m}${lang === "bg" ? "м" : "m"}`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}${lang === "bg" ? "ч" : "h"}`;
    const d = Math.floor(h / 24);
    return `${d}${lang === "bg" ? "д" : "d"}`;
  };

  return (
    <div className="card-sharp p-6" data-testid="activity-feed">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Activity className="w-4 h-4 text-pitch" />
          <h2 className="font-oswald uppercase text-xl tracking-tight">{t("activityFeed")}</h2>
        </div>
      </div>
      {items.length === 0 ? (
        <div className="py-8 text-center text-white/30 text-xs font-mono tracking-widest">
          {t("noActivity")}
        </div>
      ) : (
        <div className="space-y-1">
          {items.slice(0, limit).map((n, i) => {
            const Icon = iconFor(n.type);
            return (
              <div
                key={n.id}
                className="flex items-start gap-3 py-2.5 border-b border-white/5 last:border-b-0 animate-fade-up"
                style={{ animationDelay: `${i * 40}ms`, opacity: 0 }}
                data-testid={`activity-${n.id}`}
              >
                <div className="w-7 h-7 flex-shrink-0 bg-pitch/10 text-pitch flex items-center justify-center">
                  <Icon className="w-3.5 h-3.5" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm">
                    <span className="font-oswald uppercase tracking-tight">{n.actor_name || "System"}</span>{" "}
                    <span className="text-white/50">{n.body || n.title}</span>
                  </div>
                  <div className="text-[10px] font-mono text-white/30">{ago(n.created_at)}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
